// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--2F4Eg","footer__logo_img":"Footer-module--footer__logo_img--1JK-o","footer__links":"Footer-module--footer__links--3t4iZ"};